import { Dispatch } from 'redux';
import {
    TOGGLE_REGISTERING_USER,
    ToggleRegisteringUserAction,
    UserActionTypes,
} from '../types';

export function toggleRegisteringUser(
    registeringUser: boolean
): (dispatch: Dispatch<UserActionTypes>) => void {
    return (dispatch: Dispatch<UserActionTypes>) => {
        dispatch(receiveToggleRegisteringUser(registeringUser));
    };
}

const receiveToggleRegisteringUser = (
    registeringUser: boolean
): ToggleRegisteringUserAction => {
    return {
        type: TOGGLE_REGISTERING_USER,
        registeringUser: registeringUser,
    };
};
